import { render, staticRenderFns } from "./StageTestCompleted.vue?vue&type=template&id=6d9c716d&scoped=true&"
import script from "./StageTestCompleted.vue?vue&type=script&lang=js&"
export * from "./StageTestCompleted.vue?vue&type=script&lang=js&"
import style0 from "./StageTestCompleted.vue?vue&type=style&index=0&id=6d9c716d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9c716d",
  null
  
)

component.options.__file = "StageTestCompleted.vue"
export default component.exports